// PDF export helper — built on jsPDF + autoTable. Supports Arabic RTL with Amiri font.
// Usage: downloadPDF({ title, headers, rows, filename, subtitle, summary })
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { formatKSA } from "./ksaTime";

function reverseArabic(text) {
  // jsPDF doesn't natively support Arabic shaping. As a practical compromise we just
  // pass the string through; modern jsPDF + a Unicode font (Amiri) renders RTL correctly
  // when isInputVisual is true. For complex Arabic shaping we'd need bidirectional libs.
  return String(text == null ? "" : text);
}

export function downloadPDF({ title, headers, rows, filename = "report", subtitle, summary }) {
  const doc = new jsPDF({ orientation: "landscape", unit: "pt", format: "a4" });

  // Header band
  doc.setFillColor(110, 78, 61);  // var(--brown)
  doc.rect(0, 0, doc.internal.pageSize.getWidth(), 60, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(18);
  doc.text(reverseArabic(title || "تقرير"), 40, 36);
  if (subtitle) {
    doc.setFontSize(11);
    doc.setTextColor(220, 220, 220);
    doc.text(reverseArabic(subtitle), 40, 52);
  }

  // Date
  doc.setFontSize(9);
  doc.setTextColor(180, 180, 180);
  doc.text(`Generated: ${formatKSA(new Date())}`,
           doc.internal.pageSize.getWidth() - 40, 36, { align: "right" });

  let y = 80;

  // Optional summary section
  if (summary && Array.isArray(summary) && summary.length) {
    doc.setTextColor(40, 40, 40);
    doc.setFontSize(11);
    summary.forEach((line) => {
      doc.text(reverseArabic(line), 40, y);
      y += 16;
    });
    y += 8;
  }

  // Body table
  autoTable(doc, {
    startY: y,
    head: [headers.map(reverseArabic)],
    body: rows.map((r) => r.map(reverseArabic)),
    styles: { fontSize: 9, cellPadding: 4, halign: "center", overflow: "linebreak" },
    headStyles: { fillColor: [110, 78, 61], textColor: 255, halign: "center" },
    alternateRowStyles: { fillColor: [248, 244, 236] },
    margin: { left: 30, right: 30 },
    theme: "grid",
  });

  // Footer
  const pageCount = doc.internal.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.setFontSize(8);
    doc.setTextColor(150, 150, 150);
    doc.text(`Thawany ثواني · صفحة ${i} / ${pageCount}`,
             doc.internal.pageSize.getWidth() / 2,
             doc.internal.pageSize.getHeight() - 15,
             { align: "center" });
  }

  doc.save(`${filename}.pdf`);
}
